import { googleAnalyticsService, GoogleAnalytics } from '@services/googleAnalyticsService';
import { useMemo } from 'react';

export const useGoogleAnalytics = (): googleAnalyticsService => {
    return useMemo(() => {
        return new GoogleAnalytics();
    }, []);
};
